// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JointSigningStep_card__\\+CDvX {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 16px;
  background-color: #fafafa;
  border-radius: 4px;
  padding: 14px;
  cursor: pointer;
  height: 220px;
  line-height: 1.3;
}
.JointSigningStep_card__\\+CDvX.JointSigningStep_active__aF3ka, .JointSigningStep_card__\\+CDvX:hover {
  background-color: #fff;
}
.JointSigningStep_card__\\+CDvX .JointSigningStep_cardHeader__euSac {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.JointSigningStep_card__\\+CDvX .JointSigningStep_cardHeader__euSac .JointSigningStep_step__ubYZ3 {
  color: rgba(17, 17, 17, 0.568627451);
  font-size: 12px;
  text-transform: uppercase;
}
.JointSigningStep_card__\\+CDvX .JointSigningStep_cardBody__DhKIN {
  flex: 1 1;
  font-size: 20px;
  font-weight: 300;
}
.JointSigningStep_card__\\+CDvX .JointSigningStep_cardFooter__oaf3S {
  color: rgba(17, 17, 17, 0.568627451);
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}
.JointSigningStep_card__\\+CDvX .JointSigningStep_cardFooter__oaf3S .JointSigningStep_comments__v-WMP,
.JointSigningStep_card__\\+CDvX .JointSigningStep_cardFooter__oaf3S .JointSigningStep_date__EQm24 {
  font-size: 12px;
}

.JointSigningStep_signedBy__ku4VN {
  display: inline-block;
  vertical-align: middle;
  font-size: 10px;
  white-space: nowrap;
  max-width: 128px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.JointSigningStep_checkIcon__KXJPE {
  color: #15ad5c;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/JointDetails/JointSigningStep.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AACF;AACE;EAEE,sBAAA;AAAJ;AAGE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAEI;EACE,oCAAA;EACA,eAAA;EACA,yBAAA;AAAN;AAIE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAKE;EACE,oCAAA;EACA,aAAA;EACA,2BAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAHJ;AAII;;EAEE,eAAA;AAFN;;AAOA;EACE,qBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAJF;;AAMA;EACE,cAAA;AAHF","sourcesContent":[".card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  background-color: #fafafa;\r\n  border-radius: 4px;\r\n  padding: 14px;\r\n  cursor: pointer;\r\n  height: 220px;\r\n  line-height: 1.3;\r\n\r\n  &.active,\r\n  &:hover {\r\n    background-color: #fff; // White background\r\n  }\r\n\r\n  .cardHeader {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 8px;\r\n    .step {\r\n      color: #11111191;\r\n      font-size: 12px;\r\n      text-transform: uppercase;\r\n    }\r\n  }\r\n\r\n  .cardBody {\r\n    flex: 1;\r\n    font-size: 20px;\r\n    font-weight: 300;\r\n  }\r\n\r\n  .cardFooter {\r\n    color: #11111191;\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-top: 8px;\r\n    .comments,\r\n    .date {\r\n      font-size: 12px;\r\n    }\r\n  }\r\n}\r\n\r\n.signedBy {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  font-size: 10px;\r\n  white-space: nowrap;\r\n  max-width: 128px;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n.checkIcon {\r\n  color: #15ad5c;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `JointSigningStep_card__+CDvX`,
	"active": `JointSigningStep_active__aF3ka`,
	"cardHeader": `JointSigningStep_cardHeader__euSac`,
	"step": `JointSigningStep_step__ubYZ3`,
	"cardBody": `JointSigningStep_cardBody__DhKIN`,
	"cardFooter": `JointSigningStep_cardFooter__oaf3S`,
	"comments": `JointSigningStep_comments__v-WMP`,
	"date": `JointSigningStep_date__EQm24`,
	"signedBy": `JointSigningStep_signedBy__ku4VN`,
	"checkIcon": `JointSigningStep_checkIcon__KXJPE`
};
export default ___CSS_LOADER_EXPORT___;
